var newTable = (index) => {
  generateTable(index);
}

var addSubstractOneRow = (input, status, index) => {
  console.log('INPUT: ', input)
  console.log('STATUS: ', status)
  //console.log('INDEX: ', index)
  //var quantity = document.getElementById(input).value;
  
  
  let variantesDePlayeras  = document.getElementsByClassName('variantesDePlayeras');
        for(i = 0; i < variantesDePlayeras.length; i++) {
          if(variantesDePlayeras[i]){
             variantesDePlayeras[i] = variantesDePlayeras[i].id;
        }};

  let totalPlayeras =  parseInt(variantesDePlayeras[0].value);
  let totalChico = parseInt(variantesDePlayeras[1].value);
  let totalJuvenil = parseInt(variantesDePlayeras[2].value);
  let totalAdultoChico = parseInt(variantesDePlayeras[3].value);
  let totalAdultoGrande = parseInt(variantesDePlayeras[4].value);

  if (totalChico){

  }else{
    let totalChico = 0;
  }
  
  if( totalJuvenil ){

  } else{
    let totalJuvenil = 0;
  }
  
  if( totalAdultoChico){

  } else{
    let totalAdultoChico = 0;
  }
  
  if( totalAdultoGrande ){

  } else{
    let totalAdultoGrande = 0;
  }

  /*
  let totalChico = parseInt(variantesDePlayeras[0].value);
  let totalJuvenil = parseInt(variantesDePlayeras[1].value);
  let totalADULTOCHICO = parseInt(variantesDePlayeras[2].value);
  */
  
  
  let quantity = totalChico + totalJuvenil + totalAdultoChico + totalAdultoGrande ;

  
  console.log("Quantity ID: ",quantity);
  
  if(quantity>0 && status==false){
    document.getElementById(input).value =  (parseInt(document.getElementById(input).value) || 0) - 1;
      document.getElementById("qu").value = quantity - 1;
      document.getElementById("quantity").value = quantity - 1;
      var x = document.getElementsByClassName('quantity');
        for(i = 0; i < x.length; i++) {
          x[i].value = quantity - 1;
        }

  } else if(status==true){
    document.getElementById(input).value =   (parseInt(document.getElementById(input).value) || 0) + 1;
      document.getElementById("qu").value = quantity + 1;
      document.getElementById("quantity").value = quantity + 1;
      var x = document.getElementsByClassName('quantity');
        for(i = 0; i < x.length; i++) {
          x[i].value = quantity + 1;
        }
  }


  newTable(index);
}


function generateTable(index) {
  /*
  const chicoElements;
  if(document.getElementById("JUVENIL 8-10")){
      const chicoElements = Array(parseInt(document.getElementById("JUVENIL 8-10").value)).fill("JUVENIL 8-10");
  }
  else{
    const chicoElements = 0;
  }
  
  if(document.getElementById("JUVENIL 12-14")){
    const juvenilElements = Array(parseInt(document.getElementById("JUVENIL 12-14").value)).fill("JUVENIL 12-14");
    console.log("juvenil definido")
  }
  else{
    const juvenilElements = 0;
  }
  
  if(document.getElementById("ADULTO CHICO")){
    const adultoChicoElements = Array(parseInt(document.getElementById("ADULTO CHICO").value)).fill("ADULTO CHICO");
  }
  else{
    const adultoChicoElements = 0;
  }
  if(document.getElementById("ADULTO GRANDE")){
    const adultoGrandeElements = Array(parseInt(document.getElementById("ADULTO GRANDE").value)).fill("ADULTO GRANDE");
  }
  else{
    const adultoGrandeElements = 0;
  }
  */

    const chicoElements = Array(parseInt(document.getElementById("JUVENIL 8-10").value)).fill("JUVENIL 8-10");
    const juvenilElements = Array(parseInt(document.getElementById("JUVENIL 12-14").value)).fill("JUVENIL 12-14");
    const adultoChicoElements = Array(parseInt(document.getElementById("ADULTO CHICO").value)).fill("ADULTO CHICO");
    const adultoGrandeElements = Array(parseInt(document.getElementById("ADULTO GRANDE").value)).fill("ADULTO GRANDE");

  
  const elementscantidadVariante = [
    ...chicoElements,
    ...juvenilElements,
    ...adultoChicoElements,
    ...adultoGrandeElements
  ]
  //var elementscantidadVariante = ["JUVENIL 12-14", "ADULTO CHICO", "ADULTO GRANDE"]
  var quantity = document.getElementById("quantity").value;
  var tableContainer = document.getElementById("table-container");

  // Limpiar tabla anterior
  tableContainer.innerHTML = "";

  // Crear tabla
  var table = document.createElement("table");
  table.classList.add("table");
  table.classList.add("table-striped");
  table.classList.add("table-hover");
  table.classList.add("table-borderless");

  var thead = document.createElement("thead");
  thead.classList.add("table-dark");

  var tbody = document.createElement("tbody");
  tbody.classList.add("table-group-divider");

  // Crear encabezado de columna
  var headerRow = document.createElement("tr");
  headerRow.classList.add("text-center");

  var nameHeader = document.createElement("th");
  nameHeader.textContent = "Nombre";
  headerRow.appendChild(nameHeader);

  var sizeHeader = document.createElement("th");
  sizeHeader.textContent = "Talla";
  headerRow.appendChild(sizeHeader);

  var numberHeader = document.createElement("th");
  numberHeader.textContent = "Numero";
  headerRow.appendChild(numberHeader);
  thead.appendChild(headerRow);

  // Generar filas y celdas
  for (var i = 0; i < quantity; i++) {
    var row = document.createElement("tr");
    var coutnpeople = 1;
    coutnpeople = coutnpeople + i;
    
    // Nombre
    var nameCell = document.createElement("td");
    var nameInput = document.createElement("input");
    nameInput.classList.add("addName");
    nameInput.classList.add("form-control");
    nameInput.setAttribute("name", "properties[Nombre-" + coutnpeople +': '+ elementscantidadVariante[i] + "]");
    nameInput.setAttribute("placeholder", "Nombre");
    nameInput.setAttribute("disabled", "disabled");
    nameInput.type = "text";
    nameCell.appendChild(nameInput);
    row.appendChild(nameCell);

    // Talla
    var sizeCell = document.createElement("td");
    sizeCell.innerHTML = elementscantidadVariante[i];
    
    row.appendChild(sizeCell);
    /*var sizeSelect = document.createElement("select");
    sizeSelect.classList.add("form-select");
    //opciones
    let optionDefault = document.createElement("option");
    optionDefault.setAttribute("selected", "selected");
    let optionDefaultTexto = document.createTextNode("Seleccione una talla");
    optionDefault.appendChild(optionDefaultTexto);

  
 
    let option2 = document.createElement("option");
    option2.setAttribute("value", "Juvenil 12-14");
    let option2Texto = document.createTextNode("Juvenil 12-14");
    option2.appendChild(option2Texto);
 
    let option3 = document.createElement("option");
    option3.setAttribute("value", "Adulto Chico");
    let option3Texto = document.createTextNode("Adulto Chico");
    option3.appendChild(option3Texto);
 
    let option4 = document.createElement("option");
    option4.setAttribute("value", "Adulto Grande");
    let option4Texto = document.createTextNode("Adulto Grande");
    option4.appendChild(option4Texto);

    sizeSelect.appendChild(optionDefault);
    sizeSelect.appendChild(option2);
    sizeSelect.appendChild(option3);
    sizeSelect.appendChild(option4);

    sizeCell.appendChild(sizeSelect);
    row.appendChild(sizeCell);*/

    // Número
    var numberCell = document.createElement("td");
    var numberInput = document.createElement("input");
    numberInput.classList.add("addNumber");
    numberInput.classList.add("form-control");
    numberInput.type = "hidden";
    numberInput.setAttribute("id", "Numero-"+ coutnpeople);
    numberInput.setAttribute("value", 0);


    numberInput.setAttribute("name", "properties[Playera-" + coutnpeople +': '+ elementscantidadVariante[i] + "]");
    numberInput.setAttribute("placeholder", "Número");
    numberCell.appendChild(numberInput);
    row.appendChild(numberCell);

    tbody.appendChild(row);
  }

  
    console.log("contador: " + coutnpeople);
    console.log('ELEMENTS',elementscantidadVariante)


  // Agregar thead y tbody a la tabla
  table.appendChild(thead);
  table.appendChild(tbody);

  // Agregar tabla al contenedor
  tableContainer.appendChild(table); 
}



//Select
var listenerUniformsCustomizing = (selectId, containerId, nombreEnEspalda) => {
  var select = document.getElementById(selectId).value;
  var container = document.getElementById(containerId);
  var nombreEnEspalda = document.getElementById(nombreEnEspalda);
  if (select == 1) {
    container.style.display = "block";
    nombreEnEspalda.style.display = "block";
  } else {
    container.style.display = "none";
    nombreEnEspalda.style.display = "none";
  }
}

//Type of short select type of short or suck
var typeOfShort = (selectId) => {
    var select = document.getElementById(selectId).value;
    var container = document.getElementById(String(select));
    var SmoothShortContainer = document.getElementById("SmoothShortContainer");
    var PremiumShortContainer = document.getElementById("PremiumShortContainer");
    var SmoothSocksContainer = document.getElementById("SmoothSocksContainer");
    var PremiumSocksContainer = document.getElementById("PremiumSocksContainer");

  if(select == "SmoothShortContainer"){
      SmoothShortContainer.style.display = "block";
      PremiumShortContainer.style.display = "none";
  }
  else if(select == "PremiumShortContainer" ){
      SmoothShortContainer.style.display = "none";
      PremiumShortContainer.style.display = "block";
  }
  else if(select == "SmoothSocksContainer" ){
      SmoothSocksContainer.style.display = "block";
      PremiumSocksContainer.style.display = "none";
  }
  else if(select == "PremiumSocksContainer" ){
      SmoothSocksContainer.style.display = "none";
      PremiumSocksContainer.style.display = "block";
  }
}

var addToCartQuantity = (button, input) => {
  var quantity = document.getElementById(input).value;
  document.getElementById(button).click();
}
function wait(ms){
  var start = new Date().getTime();
  var end = start;
  while(end < start + ms) {
    end = new Date().getTime();
 }
}


document.getElementById('agregarNombre').addEventListener('click', function(e) {
        var addName = document.getElementsByClassName('addName');
        for(i = 0; i < addName.length; i++) {
          addName[i].removeAttribute("disabled");
        }
});

document.getElementById('agregarNumero').addEventListener('click', function(e) {
        var addName = document.getElementsByClassName('addNumber');
        for(i = 0; i < addName.length; i++) {
          addName[i].type ="text";
        }
});

document.getElementById('agregarNumerosConsecutivos').addEventListener('click', function(e) {
        var addName = document.getElementsByClassName('addNumber');
        var x = 2;
        for(i = 0; i < addName.length; i++) {
          addName[i].setAttribute("value", x);
          addName[i].type ="hidden";
          x++;
        }
});


$('#selectNombreColor').on('change', function() {
    var nombreColor = document.getElementById('nombreColor');
    nombreColor.setAttribute("value", this.value)
});

$('#selectNumerosColor').on('change', function() {
    var numerosColor = document.getElementById('numerosColor');
    numerosColor.setAttribute("value", this.value)
});

$('#selectNumerosConsecColor').on('change', function() {
    var numerosColor = document.getElementById('numerosConsecColor');
    numerosColor.setAttribute("value", this.value)
});
